import React from "react";
import "./landingMobile.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import Image1 from "../../../assets/images/landingGroupMobile1.svg";
import Image2 from "../../../assets/images/landingGroupMobile2.svg";
import Image3 from "../../../assets/images/landingGroupMobile3.svg";

function LandingMobile() {
  return (
    <section id="landing-carousel-mobile" className="landing-carousel-mobile">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        loop={true}
        pagination={{
          clickable: true,
          el: ".custom-swiper-pagination",
        }}
        className="swiper-container-mobile"
      >
        <SwiperSlide>
          <img src={Image1} alt="Heart Health" className="mobile-carousel-image" />
        </SwiperSlide>
        <SwiperSlide>
          <div className="carousel-slide-with-button">
            <img src={Image2} alt="Personalized Insights" className="mobile-carousel-image" />
            <a href="/services#hep" className="find-hep-button">
              Find your HEP
            </a>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img src={Image3} alt="Track Progress" className="mobile-carousel-image" />
        </SwiperSlide>
      </Swiper>
      <div className="custom-swiper-pagination"></div>
    </section>
  );
}

export default LandingMobile;